import { PackageX } from "lucide-react";
import { cn } from "@/lib/utils";
import { reportCard } from "./reportCard";

const CHIP_LIMIT = 30;

interface NeverSoldSectionProps {
  items: string[];
}

/**
 * Available menu items that never sold in the period — the strongest
 * menu-pruning signal, distinct from the barely-sold "least" list. Just names,
 * so they read best as a wrapped list of chips (SFRESTO-87).
 */
function NeverSoldSection({ items = [] }: NeverSoldSectionProps) {
  // Default to [] so a partial/rolled-back API that omits the field can't
  // crash the Rapports page (SFRESTO-98).
  if (items.length === 0) {
    return null;
  }

  const shown = items.slice(0, CHIP_LIMIT);
  const extra = items.length - shown.length;

  return (
    <section className={cn(reportCard, "p-6")}>
      <div className="mb-1 flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 text-sm font-medium uppercase tracking-wide text-muted-foreground">
          <PackageX className="h-4 w-4" />
          Jamais vendus
        </h2>
        <span className="shrink-0 text-xs text-muted-foreground">
          {items.length} article{items.length > 1 ? "s" : ""}
        </span>
      </div>
      <p className="mb-4 text-sm text-muted-foreground">
        Articles disponibles qui ne se sont pas vendus sur la période — à mettre
        en avant ou à retirer de la carte.
      </p>
      <div className="flex flex-wrap gap-2">
        {shown.map((name, index) => (
          <span
            key={`${name}-${index}`}
            className="rounded-full bg-gray-100 px-3 py-1 text-sm text-card-foreground"
          >
            {name}
          </span>
        ))}
        {extra > 0 && (
          <span className="rounded-full px-3 py-1 text-sm text-muted-foreground">
            +{extra} autres
          </span>
        )}
      </div>
    </section>
  );
}

export default NeverSoldSection;
